import { Component, Inject, OnInit } from '@angular/core';
import * as theGlobals from 'src/app/shared/globals';
import { MsalService } from '@azure/msal-angular';
import { DOCUMENT } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { LoggedInUserDto } from "../../dto/LoggedInUserDto";

@Component({
  selector: 'app-auth-button',
  templateUrl: './auth-button.component.html'
})
export class AuthButtonComponent implements OnInit {
  authProvider = theGlobals.setEnv().authProvider;
  userName = '';


  constructor(@Inject(DOCUMENT) public document: Document,
    private msalService: MsalService,
    private utilService: UtilitiesService,
    private _myUser: LoggedInUserDto,
    private cookieService: CookieService) {}

    ngOnInit() {

      this.userName = this.cookieService.get('userName');
      if (this.userName.indexOf('@') !== -1) { this.userName = this.userName.split("@")[0]; }
      this.utilService.doAudit(this.userName,' Auth Button User:');
    }

    clearCookiesAndLogout() {
      this.utilService.doAudit('Clear current user/cookies.');
      this._myUser = {
        userName: '',
        userRole: '',
        email: ''
      };
      this.cookieService.delete('userRole');
      this.cookieService.delete('userName');
      this.cookieService.delete('isFirstLogin');
      if (this.authProvider === 1) {
        this.msalService.logout();
      }
  }
  isLoggedInAD() : boolean {
    return this.msalService.instance.getActiveAccount() != null;
  }

  loginAD() {
    this.msalService.loginRedirect();
  }

}
